import bookingDataStorage from '../../data-storage';

const modBookingDataStorage = new bookingDataStorage();

export default class bookingStepFinal{

    private elFormBtn: string;
    protected elPaymentElement: string;

    constructor(
        elFormBtn: string,
        el_payment_element: string,
    ){

        this.elFormBtn = elFormBtn;
        this.elPaymentElement = el_payment_element;

    }

    async sendData(nextButtonSelector: string, formSelector: string) {

        const btn_payment = document.querySelector(this.elFormBtn);
        btn_payment?.classList.remove("hidden");
        btn_payment?.classList.add("inline-block");

        const elPayment = document.querySelector(this.elPaymentElement) as HTMLElement;
        elPayment?.classList.remove("hidden");
        elPayment?.classList.add('block');

        modBookingDataStorage.setStorageStep();

        return true;

    }

}